/**
 * X6 概念验证的硬编码演示数据。
 * 表示一个 OPM 示例模型："汽车制造"
 *
 * 结构：
 * - Car（对象）→ 包含状态：Assembled、Unassembled
 *               → 包含值：VIN-1001
 * - Engine（对象）→ 包含状态：Installed
 * - Assemble 过程：消耗 Engine，生成 Car(Assembled)
 * - Install 过程：使 Engine 变为 Installed 状态
 */

export const demoNodes = [
  // === 对象 ===
  {
    id: 'obj-car',
    shape: 'opm-object',
    x: 300,
    y: 80,
    width: 200,
    height: 222,
    data: {
      label: 'Car',
      type: 'object',
      essence: 'physical',
      affiliation: 'systemic',
      active: false,
      executionState: 'idle',
      childStateCount: 2,
    },
  },
  // === 零部件集合目标节点 ===
  {
    id: 'obj-parts-inventory',
    shape: 'opm-object',
    x: 1200,
    y: 660,
    width: 240,
    height: 110,
    data: {
      label: 'Parts Inventory',
      type: 'object',
      essence: 'physical',
      affiliation: 'systemic',
      active: false,
      executionState: 'idle',
      childStateCount: 0,
    },
  },
  {
    id: 'obj-engine',
    shape: 'opm-object',
    x: 30,
    y: 340,
    width: 184,
    height: 206,
    data: {
      label: 'Engine',
      type: 'object',
      essence: 'physical',
      affiliation: 'systemic',
      active: false,
      executionState: 'idle',
      childStateCount: 2,
    },
  },
  {
    id: 'obj-worker',
    shape: 'opm-object',
    x: 580,
    y: 340,
    width: 180,
    height: 90,
    data: {
      label: 'Worker',
      type: 'object',
      essence: 'physical',
      affiliation: 'systemic',
      active: false,
      executionState: 'idle',
      childStateCount: 0,
    },
  },
  {
    id: 'obj-blueprint',
    shape: 'opm-object',
    x: 300,
    y: 580,
    width: 200,
    height: 80,
    data: {
      label: 'Assembly Blueprint',
      type: 'object',
      essence: 'informational',
      affiliation: 'systemic',
      active: false,
      executionState: 'idle',
      childStateCount: 0,
    },
  },

  // === 状态（Car 的子节点） ===
  {
    id: 'state-unassembled',
    shape: 'opm-state',
    x: 316,
    y: 146,
    width: 80,
    height: 60,
    data: {
      label: 'Unassembled',
      type: 'state',
      essence: 'informational',
      active: false,
      executionState: 'idle',
      parentId: 'obj-car',
    },
  },
  {
    id: 'state-assembled',
    shape: 'opm-state',
    x: 404,
    y: 146,
    width: 80,
    height: 60,
    data: {
      label: 'Assembled',
      type: 'state',
      essence: 'informational',
      active: false,
      executionState: 'idle',
      parentId: 'obj-car',
    },
  },

  // === 状态（Engine 的子节点） ===
  {
    id: 'state-installed',
    shape: 'opm-state',
    x: 42,
    y: 406,
    width: 80,
    height: 60,
    data: {
      label: 'Installed',
      type: 'state',
      essence: 'informational',
      active: false,
      executionState: 'idle',
      parentId: 'obj-engine',
    },
  },
  {
    id: 'state-uninstalled',
    shape: 'opm-state',
    x: 130,
    y: 406,
    width: 80,
    height: 60,
    data: {
      label: 'Uninstalled',
      type: 'state',
      essence: 'informational',
      active: false,
      executionState: 'idle',
      parentId: 'obj-engine',
    },
  },
  // === 零部件对象（独立关系组，仅与 Parts Inventory 关联） ===
  {
    id: 'obj-wheel',
    shape: 'opm-object',
    x: 60,
    y: 780,
    width: 140,
    height: 80,
    data: {
      label: 'Wheel',
      type: 'object',
      essence: 'physical',
      affiliation: 'systemic',
      active: false,
      executionState: 'idle',
      childStateCount: 0,
    },
  },
  {
    id: 'obj-door',
    shape: 'opm-object',
    x: 220,
    y: 780,
    width: 140,
    height: 80,
    data: {
      label: 'Door',
      type: 'object',
      essence: 'physical',
      affiliation: 'systemic',
      active: false,
      executionState: 'idle',
      childStateCount: 0,
    },
  },
  {
    id: 'obj-window',
    shape: 'opm-object',
    x: 380,
    y: 780,
    width: 140,
    height: 80,
    data: {
      label: 'Window',
      type: 'object',
      essence: 'physical',
      affiliation: 'systemic',
      active: false,
      executionState: 'idle',
      childStateCount: 0,
    },
  },
  {
    id: 'obj-seat',
    shape: 'opm-object',
    x: 540,
    y: 780,
    width: 140,
    height: 80,
    data: {
      label: 'Seat',
      type: 'object',
      essence: 'physical',
      affiliation: 'systemic',
      active: false,
      executionState: 'idle',
      childStateCount: 0,
    },
  },
  {
    id: 'obj-frame',
    shape: 'opm-object',
    x: 700,
    y: 780,
    width: 140,
    height: 80,
    data: {
      label: 'Frame',
      type: 'object',
      essence: 'physical',
      affiliation: 'systemic',
      active: false,
      executionState: 'idle',
      childStateCount: 0,
    },
  },
  {
    id: 'obj-tire',
    shape: 'opm-object',
    x: 860,
    y: 780,
    width: 140,
    height: 80,
    data: {
      label: 'Tire',
      type: 'object',
      essence: 'physical',
      affiliation: 'systemic',
      active: false,
      executionState: 'idle',
      childStateCount: 0,
    },
  },

  // === 过程 ===
  {
    id: 'proc-assemble',
    shape: 'opm-process',
    x: 330,
    y: 280,
    width: 140,
    height: 100,
    data: {
      label: 'Assemble Car',
      type: 'process',
      essence: 'physical',
      affiliation: 'systemic',
      active: false,
      executionState: 'idle',
    },
  },
  // {
  //   id: 'proc-install',
  //   shape: 'opm-process',
  //   x: 100,
  //   y: 180,
  //   width: 120,
  //   height: 90,
  //   data: {
  //     label: 'Install Engine',
  //     type: 'process',
  //     essence: 'physical',
  //     affiliation: 'systemic',
  //     active: false,
  //     executionState: 'idle',
  //   },
  // },
  // {
  //   id: 'proc-inspect',
  //   shape: 'opm-process',
  //   x: 530,
  //   y: 150,
  //   width: 120,
  //   height: 90,
  //   data: {
  //     label: 'Quality Inspect',
  //     type: 'process',
  //     essence: 'informational',
  //     affiliation: 'systemic',
  //     active: false,
  //     executionState: 'idle',
  //   },
  // },
];

export const demoEdges = [
  // === 过程性关系：消耗（过程消耗对象） ===
  // 注意：proc-install 节点已注释，以下边暂时禁用
  // {
  //   id: 'edge-consume-engine',
  //   shape: 'opm-procedural-consumption',
  //   source: { cell: 'obj-engine' },
  //   target: { cell: 'proc-install', anchor: { name: 'left' } },
  //   data: {
  //     label: 'consumes',
  //     edgeCategory: 'procedural',
  //     edgeSubtype: 'consumption',
  //     flowIntensity: 0.8,
  //   },
  //   attrs: {
  //     label: {
  //       text: 'consumes',
  //       fill: '#595959',
  //       fontSize: 11,
  //       fontWeight: 500,
  //     },
  //   },
  // },
  // {
  //   id: 'edge-effect-car',
  //   shape: 'opm-procedural-effect',
  //   source: { cell: 'proc-install', anchor: { name: 'right' } },
  //   target: { cell: 'state-assembled', anchor: { name: 'left' } },
  //   data: {
  //     label: 'effects',
  //     edgeCategory: 'procedural',
  //     edgeSubtype: 'effect',
  //     flowIntensity: 0.6,
  //   },
  //   attrs: {
  //     label: {
  //       text: 'effects',
  //       fill: '#595959',
  //       fontSize: 11,
  //     },
  //   },
  // },

  // === 过程性关系：生成 ===
  {
    id: 'edge-gen-car',
    shape: 'opm-procedural-generation',
    source: { cell: 'proc-assemble' },
    target: { cell: 'obj-car' },
    data: {
      label: 'generates',
      edgeCategory: 'procedural',
      edgeSubtype: 'generation',
      flowIntensity: 1.0,
    },
    attrs: {
      label: {
        text: 'generates',
        fill: '#595959',
        fontSize: 11,
      },
    },
  },

  // === 过程性关系：消耗（Engine → Assemble） ===
  {
    id: 'edge-consume-engine',
    shape: 'opm-procedural-consumption',
    source: { cell: 'obj-engine' },
    target: { cell: 'proc-assemble' },
    data: {
      label: 'consumes',
      edgeCategory: 'procedural',
      edgeSubtype: 'consumption',
      flowIntensity: 0.8,
    },
    attrs: {
      label: {
        text: 'consumes',
        fill: '#595959',
        fontSize: 11,
        fontWeight: 500,
      },
    },
  },

  // === 过程性关系：影响（Worker → Assemble） ===
  {
    id: 'edge-effect-worker',
    shape: 'opm-procedural-effect',
    source: { cell: 'obj-worker' },
    target: { cell: 'proc-assemble' },
    data: {
      label: 'affects',
      edgeCategory: 'procedural',
      edgeSubtype: 'effect',
      flowIntensity: 0.6,
    },
    attrs: {
      label: {
        text: 'affects',
        fill: '#595959',
        fontSize: 11,
      },
    },
  },

  // === 过程性关系：消耗（Blueprint → Assemble） ===
  {
    id: 'edge-consume-blueprint',
    shape: 'opm-procedural-consumption',
    source: { cell: 'obj-blueprint' },
    target: { cell: 'proc-assemble' },
    data: {
      label: 'consumes',
      edgeCategory: 'procedural',
      edgeSubtype: 'consumption',
      flowIntensity: 0.5,
    },
    attrs: {
      label: {
        text: 'consumes',
        fill: '#595959',
        fontSize: 11,
        fontWeight: 500,
      },
    },
  },

  // === 过程性关系：调用 ===
  // 注意：proc-install 和 proc-inspect 节点已注释，以下边暂时禁用
  // {
  //   id: 'edge-invoke-install',
  //   shape: 'opm-procedural-invocation',
  //   source: { cell: 'proc-assemble', anchor: { name: 'left' } },
  //   target: { cell: 'proc-install', anchor: { name: 'right' } },
  //   data: {
  //     label: 'invokes',
  //     edgeCategory: 'procedural',
  //     edgeSubtype: 'invocation',
  //     flowIntensity: 0.5,
  //   },
  //   attrs: {
  //     label: {
  //       text: 'invokes',
  //       fill: '#595959',
  //       fontSize: 11,
  //       fontStyle: 'italic',
  //     },
  //   },
  // },
  // {
  //   id: 'edge-invoke-inspect',
  //   shape: 'opm-procedural-invocation',
  //   source: { cell: 'proc-assemble', anchor: { name: 'right' } },
  //   target: { cell: 'proc-inspect', anchor: { name: 'left' } },
  //   data: {
  //     label: 'invokes',
  //     edgeCategory: 'procedural',
  //     edgeSubtype: 'invocation',
  //     flowIntensity: 0.5,
  //   },
  //   attrs: {
  //     label: {
  //       text: 'invokes',
  //       fill: '#595959',
  //       fontSize: 11,
  //       fontStyle: 'italic',
  //     },
  //   },
  // },

  // // === 结构性关系：聚合 ===
  // {
  //   id: 'edge-agg-engine',
  //   shape: 'opm-structural-aggregation',
  //   source: { cell: 'obj-engine' },
  //   target: { cell: 'obj-car', anchor: { name: 'left' } },
  //   data: {
  //     label: 'aggregation',
  //     edgeCategory: 'structural',
  //     edgeSubtype: 'aggregation-participation',
  //   },
  //   attrs: {
  //     label: {
  //       text: 'participates',
  //       fill: '#8c8c8c',
  //       fontSize: 10,
  //     },
  //   },
  // },

  // // === 结构性关系：展示 ===
  // {
  //   id: 'edge-exhibit-worker',
  //   shape: 'opm-structural-exhibition',
  //   source: { cell: 'obj-worker', anchor: { name: 'left' } },
  //   target: { cell: 'proc-assemble', anchor: { name: 'right' } },
  //   data: {
  //     label: 'exhibition',
  //     edgeCategory: 'structural',
  //     edgeSubtype: 'exhibition-characterization',
  //   },
  //   attrs: {
  //     label: {
  //       text: 'characterizes',
  //       fill: '#8c8c8c',
  //       fontSize: 10,
  //     },
  //   },
  // },

  // // === 结构性关系：泛化 ===
  // {
  //   id: 'edge-gen-blueprint',
  //   shape: 'opm-structural-exhibition',
  //   source: { cell: 'obj-blueprint' },
  //   target: { cell: 'proc-assemble', anchor: { name: 'bottom' } },
  //   data: {
  //     label: 'generalization',
  //     edgeCategory: 'structural',
  //     edgeSubtype: 'generalization-specialization',
  //   },
  //   attrs: {
  //     label: {
  //       text: 'specializes',
  //       fill: '#8c8c8c',
  //       fontSize: 10,
  //     },
  //   },
  // },

  // === 结构性关系：聚合（6个零部件 → Parts Inventory，同类型边合并展示） ===
  {
    id: 'edge-agg-wheel',
    shape: 'opm-structural-aggregation',
    source: { cell: 'obj-wheel' },
    target: { cell: 'obj-parts-inventory' },
    data: {
      label: 'participates',
      edgeCategory: 'structural',
      edgeSubtype: 'aggregation-participation',
    },
    attrs: {
      label: {
        text: 'participates',
        fill: '#8c8c8c',
        fontSize: 10,
      },
    },
  },
  {
    id: 'edge-agg-door',
    shape: 'opm-structural-aggregation',
    source: { cell: 'obj-door' },
    target: { cell: 'obj-parts-inventory' },
    data: {
      label: 'participates',
      edgeCategory: 'structural',
      edgeSubtype: 'aggregation-participation',
    },
    attrs: {
      label: {
        text: 'participates',
        fill: '#8c8c8c',
        fontSize: 10,
      },
    },
  },
  {
    id: 'edge-agg-window',
    shape: 'opm-structural-aggregation',
    source: { cell: 'obj-window' },
    target: { cell: 'obj-parts-inventory' },
    data: {
      label: 'participates',
      edgeCategory: 'structural',
      edgeSubtype: 'aggregation-participation',
    },
    attrs: {
      label: {
        text: 'participates',
        fill: '#8c8c8c',
        fontSize: 10,
      },
    },
  },
  {
    id: 'edge-agg-seat',
    shape: 'opm-structural-aggregation',
    source: { cell: 'obj-seat' },
    target: { cell: 'obj-parts-inventory' },
    data: {
      label: 'participates',
      edgeCategory: 'structural',
      edgeSubtype: 'aggregation-participation',
    },
    attrs: {
      label: {
        text: 'participates',
        fill: '#8c8c8c',
        fontSize: 10,
      },
    },
  },
  {
    id: 'edge-agg-frame',
    shape: 'opm-structural-aggregation',
    source: { cell: 'obj-frame' },
    target: { cell: 'obj-parts-inventory' },
    data: {
      label: 'participates',
      edgeCategory: 'structural',
      edgeSubtype: 'aggregation-participation',
    },
    attrs: {
      label: {
        text: 'participates',
        fill: '#8c8c8c',
        fontSize: 10,
      },
    },
  },
  {
    id: 'edge-agg-tire',
    shape: 'opm-structural-aggregation',
    source: { cell: 'obj-tire' },
    target: { cell: 'obj-parts-inventory' },
    data: {
      label: 'participates',
      edgeCategory: 'structural',
      edgeSubtype: 'aggregation-participation',
    },
    attrs: {
      label: {
        text: 'participates',
        fill: '#8c8c8c',
        fontSize: 10,
      },
    },
  },

  // === 执行者边（Worker → Process） ===
  // {
  //   id: 'edge-agent-worker',
  //   shape: 'opm-procedural-consumption',
  //   source: { cell: 'obj-worker', anchor: { name: 'top' } },
  //   target: { cell: 'proc-assemble', anchor: { name: 'bottom' } },
  //   data: {
  //     label: 'agent',
  //     edgeCategory: 'procedural',
  //     edgeSubtype: 'consumption',
  //     flowIntensity: 0.4,
  //   },
  //   attrs: {
  //     line: {
  //       stroke: '#595959',
  //       strokeWidth: 1.8,
  //     },
  //     label: {
  //       text: 'agent',
  //       fill: '#595959',
  //       fontSize: 11,
  //       fontWeight: 500,
  //     },
  //   },
  // },

  // === 工具边（Blueprint → Process） ===
  // {
  //   id: 'edge-instrument-blueprint',
  //   shape: 'opm-procedural-consumption',
  //   source: { cell: 'obj-blueprint', anchor: { name: 'right' } },
  //   target: { cell: 'proc-inspect', anchor: { name: 'bottom' } },
  //   data: {
  //     label: 'instrument',
  //     edgeCategory: 'procedural',
  //     edgeSubtype: 'consumption',
  //     flowIntensity: 0.3,
  //   },
  //   attrs: {
  //     line: {
  //       stroke: '#595959',
  //       strokeWidth: 1.8,
  //     },
  //     label: {
  //       text: 'instrument',
  //       fill: '#595959',
  //       fontSize: 11,
  //       fontWeight: 500,
  //     },
  //   },
  // },
];
